import {
    CLEAR_FILTER,
    NO_NIGHT_TRANSFER_SELECT,
    PARENT_FILTERS_CHANGED,
    RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS,
    STOPS_RECEIVED,
    STOPS_SELECT
} from "../../actions/FlightsActions";

export const initialState = {
    stops: -1,
    noNightTransfer: false,
    maxStops: {}
};

const StopsFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case STOPS_SELECT:
            return {
                ...state,
                stops: action.stops
            };
        case NO_NIGHT_TRANSFER_SELECT:
            return {
                ...state,
                noNightTransfer: action.noNightTransfer
            };
        case STOPS_RECEIVED:
            let stops = action.maxStops;
            Object.keys(state.maxStops).map((stopKey) => {
                if (state.maxStops[stopKey] < stops[stopKey] ) {
                    stops[stopKey] = state.maxStops[stopKey];
                }

                return true;
            });

            return {...state, maxStops: stops};
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'stops') {
                return {
                    ...state,
                    stops: action.payload,
                };
            } else if (action.name === 'noNightTransfer') {
                return {
                    ...state,
                    noNightTransfer: action.payload
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state,
                stops: action.filters.stops,
                noNightTransfer: action.filters.noNightTransfer
            };
        case CLEAR_FILTER:
            if (action.filter === 'stops') {
                return {...state, noNightTransfer: initialState.noNightTransfer, stops: initialState.stops};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, noNightTransfer: initialState.noNightTransfer, stops: initialState.stops};
        default:
            return state
    }
};

export default StopsFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/StopsFilterReducer.js